import React, { useCallback, useState } from 'react';

import { ModalInfo, Intl, PaymentModal } from 'components';
import { Button, Col, Row } from 'reactstrap';
import stripeLogo from 'assets/img/stripe.svg';

export default ({
  data = {}, open, onClose, onSubmit, onSuccessPayment,
}) => {
  console.log(data)
  const [paymentModal, setPaymentModal] = useState(false);
  const [show, setShow] = useState(true);

  const togglePaymentModal = useCallback(() => {
    setShow((state) => !state);
    setPaymentModal((state) => !state);
  }, []);

  return (
    <>{show ?
      <ModalInfo
        translateTitle={false}
        open={open}
        size="lg"
        onClose={onClose}
        footer={(
          <Button
            color="app-default"
            size="app-sm"
            className="font-weight-700"
            onClick={onClose}
          >
            <Intl id="cancel" />
          </Button>
        )}
      >
        <p className="text-center">
          {data.type === 'month' && <Intl id="selectPaymentMethodMonthly" />}
          {data.type === 'year' && <Intl id="selectPaymentMethodAnual" />}
        </p>

        <Col md={7} lg={4} className="m-auto">
          <Row>
            <Col className="offset-md-2">
              <div className="bg-mp-orange-7 d-flex align-items-center px-2" style={{ height: 33 }}>
                {data.amount || <span />}
              </div>
            </Col>
            <Col md="auto" className="pl-md-0 mt-1 text-sm">
              <Intl id="euros" />
            </Col>
          </Row>
          {data.iva ? (<Row className="mt-3">
            <Col md={2} className="mt-1 text-md-right p-md-0 text-sm">
              <Intl id="iva" />
            </Col>
            <Col md>
              <div className="bg-mp-gray-3 d-flex align-items-center px-2" style={{ height: 33 }}>
                {data.iva || <span />}
              </div>
            </Col>
            <Col md="auto" className="pl-md-0 mt-1 text-sm">
              <Intl id="euros" />
            </Col>
          </Row>) : null}


          <Row className="mt-1">
            <Col md={2} className="mt-1 text-md-right p-md-0 text-sm">
              <Intl id="total" />
            </Col>
            <Col md>
              <div className="bg-mp-gray-3 d-flex align-items-center px-2" style={{ height: 33 }}>
                {data.total || <span />}
              </div>
            </Col>
            <Col md="auto" className="pl-md-0 mt-1 text-sm">
              <Intl id="euros" />
            </Col>
          </Row>

          <Row>
            <Col className="error text-center mt-2">
              <Intl id="continuePaymentConfirmation" />
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md>
              <Button
                color="app-default"
                block
                onClick={togglePaymentModal}
              >
                <img src={stripeLogo} alt="Stripe" />
              </Button>
            </Col>
          </Row>
        </Col>
      </ModalInfo> : null}

      {paymentModal
        && (
          <PaymentModal
            paymentData={data}
            open={paymentModal}
            onClose={togglePaymentModal}
            onSubmit={onSubmit}
            onSuccessPayment={onSuccessPayment}
          />
        )}
    </>
  );
};
